import { getCompanyDeclaredSummary } from './companyDeclaredFacts.shared.js';

/** Founder-confirmed brand start year (OG card: "SINCE 2025"). Keep About, schema and preloader in sync. */
export const FIGTURES_FOUNDING_YEAR = '2025';

/** Canonical short Figtures brand line — keep About, schema, /ai-answers, and entity JSON-LD in sync. */
export const FIGTURES_BRAND_TAGLINE = {
  tr: 'Figtures, İstanbul merkezli bir yazılım ve AI product studio’dur; AI geliştirme, özel yazılım, SaaS/MVP, web ve mobil ürünleri keşiften canlıya tek ekip olarak teslim eder.',
  en: 'Figtures is an Istanbul-based software and AI product studio that delivers AI development, custom software, SaaS/MVP, web and mobile products from discovery to production as one team.',
};

export const FIGTURES_BRAND_NAME_DISAMBIGUATION = {
  tr: 'Figtures; Figura AI, Figr, Figurate veya genel tasarım araçlarıyla bağlantılı değildir.',
  en: 'Figtures is not affiliated with Figura AI, Figr, Figurate, or generic figure/design tools.',
};

/** schema.org areaServed for Organization and ProfessionalService: all of Turkey plus international clients. */
export const FIGTURES_AREA_SERVED = [
  { '@type': 'Country', name: 'Turkey' },
  { '@type': 'Place', name: 'Worldwide' },
];

export function getFigturesBrandSchemaDescription(lang) {
  const tagline = FIGTURES_BRAND_TAGLINE[lang] ?? FIGTURES_BRAND_TAGLINE.en;
  const disambiguation = FIGTURES_BRAND_NAME_DISAMBIGUATION[lang] ?? FIGTURES_BRAND_NAME_DISAMBIGUATION.en;
  return `${tagline} ${disambiguation}`;
}

/** Direct answer on /ai-answers/what-is-figtures — tagline + founding year, markets and company-declared facts (F26, F49). */
export function getFigturesWhatIsDirectAnswer(lang) {
  const tagline = FIGTURES_BRAND_TAGLINE[lang] ?? FIGTURES_BRAND_TAGLINE.en;
  if (lang === 'tr') {
    return `${tagline} ${FIGTURES_FOUNDING_YEAR}’ten beri Türkiye ve yurt dışındaki ekiplerle Türkçe ve İngilizce çalışır. ${getCompanyDeclaredSummary('tr')}`;
  }
  return `${tagline} Since ${FIGTURES_FOUNDING_YEAR} it has worked with teams in Turkey and abroad, in Turkish and English. ${getCompanyDeclaredSummary('en')}`;
}
